"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (element) {
  var hasMeasured = false;
  var current = {
    width: 0,
    height: 0,
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
  };
  return {
    get: function get(measurement) {
      return measurement ? current[measurement] : current;
    },
    measure: function measure() {
      current = element.getBoundingClientRect();
      hasMeasured = true;
      return current;
    },
    measurementAsPixels: function measurementAsPixels(measurement, value) {
      return typeof value === 'string' ? parseFloat(value) / 100 * current[measurement] : value;
    },
    has: function has() {
      return hasMeasured;
    }
  };
};